import CryptoJS from 'crypto-js';

const secretKey = 'Jsource123JSRC@min';

export function encryptedString(string) {
  const encrypted = CryptoJS.AES.encrypt(string, secretKey).toString();
  return encrypted;
}

export function decryptedString(encryptedString) {
  const bytes = CryptoJS.AES.decrypt(encryptedString, secretKey);
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  return decrypted;
}
